export const COOKIE_NAME = 'ecosia_sp2';
export const COOKIE_DOMAIN = '.ecosia.org';
export const SNOWPLOW_URL = 'https://ps.ecosia.org/FVh3ot2zPwDMi43LjI.js';
